import styled, { css } from "styled-components";
import { remCalc, media } from "../theme/style-utils-coras-nua";
import { Box } from "../theme/containers";
import {
    space,
    SpaceProps,
    layout,
    LayoutProps,
    color,
    ColorProps,
    FlexboxProps,
    position,
    PositionProps,
    border,
    BorderProps,
    background,
    BackgroundProps
} from "styled-system";
import defaultTheme from "../theme/theme-test-override";
import { ThemeProps, ThemeTemplate } from "../theme/theme-template";
type CloseIconTypes = SpaceProps &
    LayoutProps &
    ColorProps &
    FlexboxProps &
    PositionProps &
    BorderProps &
    BackgroundProps;
type StyledInfoMessageTypes = { dark?: boolean } & { centre?: boolean } & {
    fullScreen?: boolean;
} & { fixed?: boolean } & { innerDivFixed?: boolean } & {
    modalOnDesktop?: boolean;
} & ThemeProps;
const CloseIcon = styled("button")<CloseIconTypes>`
    ${position}
    ${layout}
    ${color}
    ${background}
    ${border}
    ${space}
    cursor: pointer;
`;
CloseIcon.defaultProps = {
    p: 5,
    width: remCalc(20),
    height: remCalc(20),
    backgroundColor: "brilliant",
    backgroundImage:
        "url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQtQ29weS0yIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cGF0aCBkPSJNMi4yNjc1ODA4NywxOS44NTM3ODU3IEwxMC4wMDAzMDU3LDEyLjEyMTY3MTMgTDE3LjczMjQyMDEsMTkuODUzNzg1NyBDMTcuOTI3NDMzNSwyMC4wNDg3MzgxIDE4LjI0NDMzOCwyMC4wNDg3MzgxIDE4LjQzOTI5MDMsMTkuODUzNzg1NyBMMTkuODUzNzYzMywxOC40MzkzMTI4IEMyMC4wNDg3MTU3LDE4LjI0NDM2MDQgMjAuMDQ4NzE1NywxNy45Mjc0NTU5IDE5Ljg1Mzc2MzMsMTcuNzMyNDQyNSBMMTIuMTIxNjQ4OSwxMC4wMDAzMjgxIEwxOC41MzE4MjI1LDMuNTkwMTU0NDIgTDE5Ljg1Mzc2MzMsMi4yNjgyMTM2NSBDMjAuMDQ4NzE1NywyLjA3MzIwMDIzIDIwLjA0ODcxNTcsMS43NTYyOTU3OCAxOS44NTM3NjMzLDEuNTYxMzQzNCBMMTguNDM5MjkwMywwLjE0Njg3MDQzOSBDMTguMjQ0MzM4LC0wLjA0ODA4MTk0ODQgMTcuOTI3NDMzNSwtMC4wNDgwODE5NDg0IDE3LjczMjQyMDEsMC4xNDY4NzA0MzkgTDEwLjAwMDMwNTcsNy44Nzg5ODQ4NiBMMi4yNjgxOTEyNCwwLjE0NjI2MDA2OCBDMi4wNzMxNzc4MiwtMC4wNDg3NTMzNTYxIDEuNzU2MjczMzcsLTAuMDQ4NzUzMzU2MSAxLjU2MTMyMDk4LDAuMTQ2MjYwMDY4IEwwLjE0NjIzNzY1NywxLjU2MDY3MTk5IEMtMC4wNDg3NzU3Njc0LDEuNzU1Njg1NDEgLTAuMDQ4Nzc1NzY3NCwyLjA3MjU4OTg2IDAuMTQ2MjM3NjU3LDIuMjY3NjAzMjggTDcuODc4OTYyNDUsMTAuMDAwMzI4MSBMMC4xNDYyMzc2NTcsMTcuNzMyNDQyNSBDLTAuMDQ4Nzc1NzY3NCwxNy45Mjc0NTU5IC0wLjA0ODc3NTc2NzQsMTguMjQ0MzYwNCAwLjE0NjIzNzY1NywxOC40MzkzMTI4IEwxLjU2MDY0OTU4LDE5Ljg1Mzc4NTcgQzEuNzU1NjYzLDIwLjA0ODczODEgMi4wNzI1Njc0NCwyMC4wNDg3MzgxIDIuMjY3NTgwODcsMTkuODUzNzg1NyBaIiBpZD0idCIgZmlsbD0iIzA1M0M1OSIgZmlsbC1ydWxlPSJub256ZXJvIj48L3BhdGg+CiAgICA8L2c+Cjwvc3ZnPg==')",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    border: "none"
};
const StyledInfoMessage = styled(Box)<StyledInfoMessageTypes>`
${props =>
    props.modalOnDesktop &&
    css`
        ${media.lg.up`
        width: ${remCalc(512)};
        min-height: fit-content;
        margin-left: auto;
        margin-right: auto;
        top: ${remCalc(120)};

        padding-top: 0;
            &:after{
                content: ' ';
                background: rgba(73, 73, 73, .6);
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                z-index: 1;
            }
            > ${Box} {
                z-index: 2;
                position: relative;
                background: ${props.theme.colors.brilliant};
                padding: ${remCalc(24)};
                top: 0;
                height: auto;
                padding-bottom: ${remCalc(64)};

            }
        `}
    `}
    > ${Box} {
        max-width: ${remCalc(512)};
        margin-left: auto;
        margin-right: auto;
        ${media.sm.down`
            padding-left: ${remCalc(24)};
            padding-right: ${remCalc(24)};
        `}
        display: flex;
        flex-direction: column;
        ${(props) => {
            if (props.dark) {
                const color = props.theme.colors.monotoneDark;
                return css`
                    h1,
                    h2,
                    p {
                        color: ${color};
                    }
                `}
            }
        }
        ${props =>
            props.modalOnDesktop &&
            css`
                ${media.md.down`
                height: 100%;
            `}
            `}
        ${props =>
            props.fullScreen &&
            !props.modalOnDesktop &&
            css`
                height: 100%;
            `} 
            ${props =>
                props.innerDivFixed &&
                css`
                    position: fixed;
                    overflow: hidden;
                    top: 0;
                    padding-left: 20%;
                    padding-right: 20%;
                    width: 60%;
                    ${media.lg.up`
                        padding-left: ${remCalc(80)};
                        padding-right: ${remCalc(80)};
                        width: ${remCalc(512)};
                    `}
                    ${props.modalOnDesktop &&
                        css`
                            ${media.lg.up`
                                position: relative;
                                overflow: visible;
                                top: 0;
                                padding-left: ${remCalc(24)};
                                padding-right: ${remCalc(24)};
                                width: unset;
                            `}
                        `}
                    ${media.sm.down`
                        padding-left: ${remCalc(32)};
                        padding-right: ${remCalc(32)};
                        width: calc(100% - ${remCalc(64)});
                    `}
                `}
        /* Tablet considerations */
        ${media.md.only``}

        /* Desktop considerations */

        ${media.lg.up``}

        /* XL Desktop considerations */
        ${media.xl.up``}
    }
    

    
    ${props =>
        props.centre &&
        css`
            text-align: center;
            > div > *:first-child {
                margin-top: auto;
                ${media.lg.up`
                margin-top: calc(${remCalc(60)} + ${remCalc(120)});
                `}
                ${props.modalOnDesktop &&
                    css`
                        ${media.lg.up`
                             margin-top: calc(${remCalc(64)});
                        `}
                    `}
            }
            justify-content: center;
            ${!props.modalOnDesktop &&
                css`
                    ${media.lg.down`
                        overflow: auto;
                    `}
                `}
            ${props.zIndex &&
                css`
                    z-index: ${props.zIndex};
                `}
        `}

    svg {
        margin-left: auto;
        margin-right: auto;
    }
    > svg,
    > img {
        margin-bottom: ${remCalc(16)};
    }

`;
StyledInfoMessage.defaultProps = {
    zIndex: 2,
    backgroundColor: "brilliant",
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};

export { StyledInfoMessage, CloseIcon };
